import { make } from '../Model';
import { MemberWarningCategory } from './MemberWarningCategory';
import { MemberWarningType } from './MemberWarningType';

const WARNING_SORT = {
  [MemberWarningCategory.APPOINTMENT]: 0,
  [MemberWarningCategory.TIME]: 5,
  [MemberWarningCategory.MISSING_INFO]: 10,
  [MemberWarningCategory.OPEN_ITEMS]: 15,
  [MemberWarningCategory.RPM_RISK]: 20,
  [MemberWarningCategory.TOC]: 25,
};
export class MemberWarning {
  type: MemberWarningType;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.type = make(obj.type, MemberWarningType);
  }

  static sort = (
    { type: { description: ad, category: ac } }: MemberWarning,
    { type: { description: bd, category: bc } }: MemberWarning,
  ) => {
    if (WARNING_SORT[ac.id] === WARNING_SORT[bc.id])
      return ad.localeCompare(bd);
    return WARNING_SORT[ac.id] - WARNING_SORT[bc.id];
  };
}

export default MemberWarning;
